<template>
  <side-bar
    v-show="ChannelCreateSidebar"
    position-right
    class="z99-5 max-w25 hrcydivwfull"
  >
    <div class="flex sidebar-topfixpart bg-primary justify-between p-4">
      <h2 class="h2-class font-semibold text-white">CREATE COMMUNITY</h2>

      <feather-icon
        icon="XIcon"
        @click="closeSidebar()"
        class="cursor-pointer text-white"
        svgClasses="w-6"
      ></feather-icon>
    </div>
    <div class="p-4 scroll-85vh">
      <div class="mb-4">
        <p
          class="text-sm text-gray-600 font-medium px-2 py-1 mb-1 border rounded bg-gray-100 inline-block"
        >
          Recommended Size: 400px × 400px
        </p>
        <FileUploader :onSuccess="loadImage" v-if="!SelectedImage" />
        <!-- <img :src="renderedImage" v-else /> -->
        <Cropper
          class="cropper"
          :src="renderedImage"
          v-if="SelectedImage != ''"
          @change="chnage"
          ref="cropper"
          :default-size="defaultSize"
        />
      </div>
      <b-form>
        <div class="mb-4">
          <p class="font-semibold text-sm mb-2">Community Name</p>
          <b-input
            @change="(text) => (Name = text)"
            :value="Name"
            placeholder="Enter Community Name..."
            class="form-control-muted"
          />
        </div>
        <div class="mb-4">
          <base-input label="Community Description">
            <textarea
              @change="(e) => (Description = e.target.value)"
              :value="Description"
              placeholder="Enter Community Description..."
              class="form-control form-control-muted"
              id="channel-description"
              rows="3"
            ></textarea>
          </base-input>
        </div>
      </b-form>
      <div class="mt-8">
        <div>
          <h2 class="font-semibold text-sm mb-4">Community Type</h2>
          <b-nav pills>
            <b-nav-item
              v-for="(type, index) in ChannelTypes"
              v-bind:key="index"
              :active="type.text === Type"
              @click="
                Type = type.text;
                Type === 'Private'
                  ? (isShowCollapse = true)
                  : (isShowCollapse = false);
              "
              v-b-toggle.isShowCollapse
            >
              {{ type.text }}</b-nav-item
            >
          </b-nav>
          <br />
          <b-collapse id="isShowCollapse" v-if="isShowCollapse == true">
            <!-- <b-input
                v-model="Price"
                placeholder="Enter amount"
                class="form-control-muted"
              /> -->
            <div class="mb-4">
              <div class="w-1/2 pr-2">
                <label class="col-form-label form-control-label"
                  >Plan Type</label
                >
                <base-input class="mt-8">
                  <select
                    @change="getSelectedPlan"
                    v-model="planId"
                    class="form-control"
                  >
                    <option
                      v-for="plan in membership"
                      :key="plan._id"
                      :label="plan.name"
                      :value="plan._id"
                    >
                      {{ plan.name }}
                    </option>
                  </select>
                </base-input>
              </div>
            </div>
          </b-collapse>
        </div>
      </div>

      <div class="mt-8">
        <div>
          <h2 class="font-semibold text-sm mb-4">Posting Rights</h2>
          <b-nav pills tabContentClasses="px-12">
            <b-nav-item
              v-for="(right, index) in ChannelPostingRights"
              v-bind:key="index"
              :active="right === PostingRight"
              @click="PostingRight = right"
              >{{ right }}</b-nav-item
            >
          </b-nav>
        </div>
        <base-button
          block
          type="primary"
          class="rounded font-semibold lg:mt-8 md:mt-8"
          @click="CreateChannel()"
          :disabled="!isValid"
          >SUBMIT</base-button
        >
        <div>
          <!-- Using modifiers -->

          <!-- Using value -->

          <!-- Element to collapse -->
        </div>
      </div>
    </div>
    <!-- <footer
        class="footer-fix md:fixed lg:fixed bottom-0 md:w-1/4 lg:w-1/4 w-full mobile-sidebarfooter"
      >
        <base-button
          block
          type="primary"
          class="rounded-none font-semibold"
          @click="CreateChannel()"
          :disabled="!isValid"
          >SUBMIT</base-button
        >
      </footer> -->
  </side-bar>
</template>
<script>
import FileUploader from "@/components/FileUploader.vue";
import { mapState } from "vuex";
import { Cropper } from "vue-advanced-cropper";
import "vue-advanced-cropper/dist/style.css";
export default {
  components: {
    FileUploader,
    Cropper,
  },
  props: {
    ChannelCreateSidebar: {
      type: Boolean,
    },
  },
  data() {
    return {
      isShowCollapse: false,
      Name: "",

      Description: "",
      Type: "",
      planId: "",
      SelectedImage: null,
      renderedImage: null,
      cropperImg: "",
      PostingRight: "",
      ChannelTypes: [
        {
          id: "01",
          text: "Private",
        },
        {
          id: "02",
          text: "Public",
        },
      ],
      ChannelPostingRights: ["Anyone", "Admin Only"],
      Price: 0,
    };
  },

  methods: {
    async getMembership() {
      let payload = {};
      const data = await this.$store.dispatch(
        "membership/getAllMembership",
        payload
      );
      // console.log({ mem: data });
    },
    getSelectedPlan(data) {
      // console.log("SelectedPlan", data.target.value);
      // console.log("SelectedPlan", this.planId);
    },
    async CreateChannel() {
      let payload = new FormData();
      payload.append("name", this.Name);
      payload.append("price", this.Price);
      if (this.isShowCollapse) {
        payload.append("planId", this.planId);
      }
      payload.append("description", this.Description);
      payload.append("type", this.Type.toLowerCase());
      payload.append("postingRights", this.PostingRight.toLowerCase());
      payload.append("media", this.SelectedImage);

      let loader = this.$loading();
      try {
        await this.$store.dispatch("channel/CreateChannel", payload);
        // this.$router.push({ name: "social-admin-home" });
        // this.$emit("closeSidebar");
        this.resetForm();
        this.$emit("closeModal", true);
        this.$swal("", "Community Created", "success");
        loader.close();
      } catch (error) {
        if (error.response.status == 400) {
          this.$router.push({ name: "signin" });
          this.$swal.fire({
            title: "Session Expired",
            text: "Your session has ended and for security reasons, we request you to login again",
            icon: "warning",
            confirmButtonColor: "#830c81",
            showCancelButton: false,
          });
          loader.close();
        } else if (error) {
          loader.close();
          const { response } = error;
          this.$swal.fire({
            text: response.data.message,
            confirmButtonText: "Okay",
            icon: "error",
            confirmButtonColor: "#830c81",
            showCancelButton: false,
          });
          // this.$swal("", response.data.message, "error");
        }
      }
    },
    loadImage(image) {
      let mByte = 5 * 1048576;
      if (image.size > mByte) {
        this.$swal.fire({
          title: "File size exceeds the allowed limit!",
          // text: "Please ensure that the file size does not exceed 5MB",
          html: "<p style='text-align:center'>Please ensure that the file size does not exceed 5MB</p>",
          confirmButtonText: "Okay",
          icon: "warning",
          confirmButtonColor: "#830c81",
          showCancelButton: false,
        });
        return;
      }
      this.SelectedImage = image;
      this.readerData(image);
    },
    readerData(rawFile) {
      let loader = this.$loading();

      const reader = new FileReader();
      reader.onload = (e) => {
        this.$emit("load", (this.renderedImage = e.target.result));

        loader.close();
      };
      reader.readAsDataURL(rawFile);
    },
    closeSidebar() {
      this.resetForm();
      this.$emit("closeModal", true);
    },
    resetForm() {
      this.Name = "";
      this.Description = "";
      this.Type = "";
      this.SelectedImage = "";
      this.PostingRight = "";
      this.renderedImage = "";
    },
    defaultSize({ imageSize, visibleArea }) {
      return {
        width: (visibleArea || imageSize).width,
        height: (visibleArea || imageSize).height,
      };
    },
    dataURLtoFile(dataurl, filename) {
      var arr = dataurl.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], filename, { type: mime });
    },
    chnage(img) {
      // console.log(img);
      this.cropperImg = img;
      this.SelectedImage = this.dataURLtoFile(
        img.canvas.toDataURL(),
        "image.png"
      );
    },
  },

  computed: {
    isValid() {
      return (
        !!this.Name.trim() &&
        !!this.Description.trim() &&
        !!this.Type &&
        // !!this.SelectedImage &&
        !!this.PostingRight
      );
    },

    ...mapState("membership", { membership: "membership" }),
  },
  async mounted() {
    await this.getMembership();
    // console.log("this.membership", this.membership);
  },
};
</script>
